import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import ChallengeForm from "./form";

const UpdateChallenge = () => {
  const { jobId, challengeId } = useParams();
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Challenge" />
      <div className="p-6 max-w-2xl">
        <ChallengeForm jobId={jobId} challengeId={challengeId} />
      </div>
    </div>
  );
};

export default UpdateChallenge;
